// Document ready functions
console.log("Hello world");
